import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import {
	StyledContainer,
	StyledSectionContainer,
	StyledTitle,
} from '../../common';
import PricePreviewChangesTables from '../PricePreviewChangesTables';

interface Props {
	authData: AuthData;
	cancellationData: CancellationData;
}

const CancellationPricePreview = (props: Props) => {
	const {
		// authData,
		cancellationData,
	} = props;

	const {
		policy,
		productConfig,
		selectedCancellation,
		// cancellationUpdateObj,
	} = cancellationData;
	const priceData = selectedCancellation.price;

	const renderPriceTables = () => {
		if (!priceData) {
			return <CircularProgress />;
		}

		return (
			<PricePreviewChangesTables
				productConfig={productConfig}
				priceData={priceData}
				policy={policy}
			/>
		);
	};

	return (
		<>
			<StyledContainer>
				<StyledTitle>Pricing Breakdown</StyledTitle>
			</StyledContainer>
			<hr />
			<StyledSectionContainer>{renderPriceTables()}</StyledSectionContainer>
		</>
	);
};

export default withCancellationContext<Props>(CancellationPricePreview);
